import { defineStyle } from '@chakra-ui/react';

export const loginVariant = defineStyle({
  paddingX: 2,
  background: 'neutral.white',
  color: 'neutral.black',
  border: '2px solid',
  borderColor: 'transparent',
});
